import { render, staticRenderFns } from "./holder.vue?vue&type=template&id=7c5a0246&scoped=true&"
import script from "./holder.vue?vue&type=script&lang=js&"
export * from "./holder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5a0246",
  null
  
)

export default component.exports